import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { StyledTableCell } from "./StyledTableCell";
import { StyledTableRow } from "./StyledTableRow";

export const TableSection = ({ children }) => {
  return (
    <StyledTableRow>
      <StyledTableCell
        style={{
          minWidth: 200,
          fontWeight: "bold",
          fontSize: 20,
          fontFamily: "Caprasimo",
        }}
        component="th"
        scope="row"
        colSpan={3}
        rowSpan={1}
        align="center"
      >
        {children}
      </StyledTableCell>
    </StyledTableRow>
  );
};
